/**
 * PlantUptimeBlock — Iter 400.5.
 *
 * Compact Plant Uptime widget for the per-customer Performance tab.
 * Reuses `/api/plant-sla/sites?customer_id=<id>` so numbers match
 * the tenant-wide dashboard at /performance?view=sla, and reuses the
 * shared PlantSLABoard timeline drawer + PDF download for per-site
 * drill-in.
 *
 * Default state = "everything is UP". A site only shows less than
 * 100% uptime when there's a proven plant-down event from a support
 * ticket (Dirk 2026-02-19: "Plant uptime must always be full and
 * only count negative if proven down by support tickets"). This is
 * already the behaviour of the shared `_compute_uptime` helper — no
 * calc changes needed here.
 */
import { useState } from "react";
import { Activity } from "lucide-react";
import FoldBlock from "../customer-blocks/FoldBlock";
import PlantSLABoard from "./PlantSLABoard";

export default function PlantUptimeBlock({ customerId, defaultOpen = true }) {
  // Local state so we can pass through nothing exotic — the child
  // board handles its own load / totals / drawer. We just wrap it
  // in the standard FoldBlock header for consistency with the other
  // Performance sections (Log sheet, Performance analytics).
  const [refreshTick] = useState(0); // reserved for future manual refresh
  return (
    <FoldBlock
      icon={Activity}
      iconColor="#22d3ee"
      title="Plant uptime"
      defaultOpen={defaultOpen}
      testId="customer-plant-uptime-block"
      alwaysRenderChildren
    >
      <div className="pt-1" key={refreshTick}>
        <PlantSLABoard customerId={customerId} />
      </div>
    </FoldBlock>
  );
}
